import { getRandomColorOption } from '~/utils/colors'
import {
  SubmissionGroupStatus,
  type SubmissionGroup,
} from '~/types/SubmissionGroup'
import type { Unsaved } from '~/types/Unsaved'

export function getTestSubmissionGroupDefault(): Unsaved<SubmissionGroup> {
  return {
    name: '[New group]',
    color: getRandomColorOption({ omitSemantic: true, omitPrimary: true }),
    description: '',
    status: SubmissionGroupStatus.OPEN,
  }
}
